import { Input } from 'semantic-ui-react';

import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

const _FormInput = (props) => <Input {...props} />;

const FormInput = withFormikInput(withFormField(_FormInput));
export default FormInput;
